var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"values-block",class:_vm.classes},[_c('FlexChildrenOverflowedText',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},proxy:true}])}),_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.value))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }